import { synapse } from 'state'
import { BASE_URL } from 'config'

export const getPurgerScenarios = async (params) => {
  try {
    let url = `${BASE_URL}/scheduler/scenario-deletions`

    if (params) url += `?${params}`

    const scenarios = await synapse.fetch(url)
    return scenarios
  } catch (error) {
    console.error(error)
    return null
  }
}

export const insertPurger = async (body) => {
  try {
    return await synapse.fetch(
      `${BASE_URL}/scheduler/scenario-deletions`,
      {
        method: 'POST'
      },
      body
    )
  } catch (error) {
    console.error(error)
  }
}

export const editPurger = async (body, id) => {
  return await synapse.fetch(
    `${BASE_URL}/scheduler/scenario-deletions/${id}`,
    {
      method: 'PUT'
    },
    body
  )
}

export const simulatePurger = async ({ body, id }) => {
  return await synapse.fetch(
    `${BASE_URL}/scheduler/scenario-deletions/${id}/simulate`,
    {
      method: 'POST'
    },
    body
  )
}

export const deletePurger = async (params) => {
  return await synapse.fetch(
    `${BASE_URL}/scheduler/scenario-deletions/${params.id}`,
    {
      method: 'DELETE'
    }
  )
}

export const deleteMultiplePurger = async (params) => {
  return await synapse.fetch(
    `${BASE_URL}/scheduler/scenario-deletions?ids=${params.ids.join(',')}`,
    {
      method: 'DELETE'
    }
  )
}
